import Result from 'components/features/Result';
import SaveButton from 'components/features/Result/SaveButton';
import BaseLayout from 'components/layouts/BaseLayout';
import { appSlice } from 'modules/app/appSlice';
import React, { useEffect, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import { useDispatch } from 'react-redux';
import { RouteName } from 'types/RootStackParamList';
import { useNavigation } from '@react-navigation/native';

const styles = StyleSheet.create({
	buttonRow: {
		flexDirection: 'row',
		justifyContent: 'space-around',
		alignItems: 'center',
	},
});

const ResultScreen: React.VFC = () => {
	const navigation = useNavigation();

	const captureTargetRef = useRef<View>(null);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(appSlice.actions.expUp());
	}, []);

	return (
		<BaseLayout
			headerChildren={
				<Button
					onPress={() => {
						dispatch(appSlice.actions.resetMessage());
						navigation.navigate<RouteName>('Edit');
					}}
					mode="contained"
					icon="arrow-left">
					{'戻る'}
				</Button>
			}
			mainChildren={<Result ref={captureTargetRef} />}
			footerChildren={
				<View style={styles.buttonRow}>
					<SaveButton
						captureTargetRef={captureTargetRef}
						type="share"
					/>
					<SaveButton
						captureTargetRef={captureTargetRef}
						type="save"
					/>
				</View>
			}
		/>
	);
};

export default ResultScreen;
